import React from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import styles from './AppLayout.module.css';

/**
 * AppLayout — the calm shell. Renders the sticky sidebar (when the
 * `withSidebar` prop is set — typically when the user is signed in),
 * a Topbar with theme toggle, the page content, and a thin footer.
 *
 * Pre-login routes (Landing, Login, Signup) pass withSidebar={false}
 * so the auth pages can fill the viewport.
 */
export default function AppLayout({
  withSidebar = false,
  children,
  footer,
}) {
  return (
    <div className={`${styles.app} ${withSidebar ? styles.withSidebar : styles.noSidebar}`}>
      {withSidebar && <Sidebar />}
      <div className={styles.main}>
        {withSidebar && <Topbar />}
        <main className={styles.body}>{children}</main>
        {footer && <footer className={styles.footer}>{footer}</footer>}
      </div>
    </div>
  );
}
